export const storage = {
  getToken: () => localStorage.getItem('user'),
  setToken: (token) => localStorage.setItem('user', token),
  removeToken: () => localStorage.removeItem('user'),
  clearAll: () => localStorage.clear()
};